import React, { useState } from 'react';
import { BarChart3, Lightbulb, MessageCircle } from 'lucide-react';

const TestAnalysisPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('deep-analysis');

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">案例详情页面 Tab 测试</h1>
        
        {/* 标签页导航 */}
        <div className="bg-white rounded-lg shadow-sm mb-2">
          <div className="border-b border-gray-200">
            <nav className="flex space-x-8 px-8">
              {[{ id: 'deep-analysis', name: '深度分析', icon: BarChart3 },
                { id: 'learning-method', name: '分析思路', icon: Lightbulb },
                { id: 'my-analysis', name: '我的分析', icon: MessageCircle }].map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center py-4 px-1 border-b-2 font-medium text-sm transition-colors ${
                      activeTab === tab.id
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <Icon className="w-4 h-4 mr-2" />
                    {tab.name}
                  </button>
                );
              })}
            </nav>
          </div>
        </div>

        {/* 标签页内容 */}
        <div className="bg-white rounded-lg shadow-sm p-8">
          {activeTab === 'deep-analysis' && (
            <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">深度分析</h2>
              <p className="text-gray-600">
                这里是深度分析的内容区域。通常会显示完整的分析文章内容。
              </p>
            </div>
          )}
          
          {activeTab === 'learning-method' && (
            <div>
              <div className="text-center py-16">
                <div className="mb-6">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-blue-100 to-indigo-100 rounded-full mb-4">
                    <Lightbulb className="w-10 h-10 text-blue-600" />
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">分析思路解析</h3>
                <p className="text-lg text-gray-600 mb-6 max-w-2xl mx-auto">
                  我们正在为您精心准备详细的分析思路和方法论讲解
                </p>
                <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-8 max-w-md mx-auto">
                  <div className="flex items-center justify-center mb-4">
                    <div className="flex space-x-1">
                      <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce"></div>
                      <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
                      <div className="w-2 h-2 bg-blue-500 rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
                    </div>
                  </div>
                  <p className="text-blue-800 font-medium">敬请期待</p>
                  <p className="text-blue-600 text-sm mt-2">
                    即将为您呈现专业的分析框架和思维模式
                  </p>
                </div>
              </div>
            </div>
          )}
          
          {activeTab === 'my-analysis' && (
            <div>
              <div className="text-center py-16">
                <div className="mb-6">
                  <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-purple-100 to-pink-100 rounded-full mb-4">
                    <MessageCircle className="w-10 h-10 text-purple-600" />
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">我的分析空间</h3>
                <p className="text-lg text-gray-600 mb-6 max-w-2xl mx-auto">
                  个人分析记录和思维成长轨迹功能正在开发中
                </p>
                <div className="bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl p-8 max-w-md mx-auto">
                  <div className="flex items-center justify-center mb-4">
                    <div className="flex space-x-1">
                      <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse"></div>
                      <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse" style={{animationDelay: '0.2s'}}></div>
                      <div className="w-2 h-2 bg-purple-500 rounded-full animate-pulse" style={{animationDelay: '0.4s'}}></div>
                    </div>
                  </div>
                  <p className="text-purple-800 font-medium">敬请期待</p>
                  <p className="text-purple-600 text-sm mt-2">
                    即将支持个人分析创作和学习进度追踪
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TestAnalysisPage;